import React from "react";
import classNames from "classnames";
import { Link } from "../Link";
import { LogoQuebec } from "../Icons/LogoQuebec";
const Header = ({ children, className, fixed, title = "", renderLogo, renderSecondaryContent, style }) => (React.createElement("header", { role: "banner", className: classNames("gerudo-header", className, { "is-fixed": fixed }), style: style },
    React.createElement("div", { className: "container" },
        React.createElement("section", { className: "primary-content" },
            renderLogo ? (React.createElement("div", { className: "logo" }, renderLogo())) : (React.createElement(Link, { href: "/", className: "logo" },
                React.createElement(LogoQuebec, null))),
            Boolean(title.length) && React.createElement("h1", null, title),
            children),
        renderSecondaryContent && React.createElement("section", { className: "secondary-content" }, renderSecondaryContent()))));
export default Header;
export { Header };
//# sourceMappingURL=index.js.map